export enum ItemCountStrings {
  // Page Titles
  ProductCount = 'jjFM',

  // Column Headers
  InventoryItemName = 'BtSR',
  InventoryItemID = 'Ll/+',
  Count = 'N7rE',
  Spoilage = 'i3Ht',
  Gratis = 'EvH1',

  StartCount = 'if33',
  EndCount = '10SG',
  Item = 'ZSvM',


  // Buttons
  FinalizeCount = 'Qhi6',

  // Tabs
  ChargeableOnly = 'YqkI',
  AllItems = 'R3cw',

  // Count Types
  StartingCount = 'V5RK',
  EndingCount = 'g4io',

  // Messages
  FinalizeThisProduct = 'BH21',
  ChangeCountType = 'zjLi',
  NoAvailableStandWorksheet = 'UkQe',
  FinalizeEventNotAvailable = 'lLCd',
  FinalizeStandWorksheetNotAvailable = 'T2K7',
  NoOpenCountTypeToSelect = '7ckB',
}
